/**
 * Created by Tiger on 24/02/2022.
 */
import Types from '../types';
import {http} from '../../../common/request';
import {HttpURLS} from '../../../common/http-url-define';
import {formatEncryptType, formatNetType, formatTime} from '../../../common/util';
import {message, Modal} from 'antd';
import i18n from 'i18next';

/**
 * 获取私有化配置列表
 * @return {(function(*): void)|*}
 */
export function onRefreshConfigList() {
  return dispatch => {
    updateConfigList(dispatch);
  };
}

export function onRefreshAliHostsList(language = 'zh') {
  return dispatch => {
    dispatch({ type: Types.REFRESH_ALI_HOST_LIST });
    http('get', HttpURLS.REFRESH_AL_HOST_LIST).then(res => {
      const { code, data } = res.data;
      if (code === 200) {
        console.log('获取阿里云服务器列表成功：', data);
        dispatch({
          type: Types.REFRESH_ALI_HOST_LIST_SUCCESS, hostsList: data?.region.map(({ id, name, enName }) => {
            return {
              label: language === 'en' ? enName : name, value: id,
            };
          }),
        });
      } else {
        console.log('获取服务器列表失败', code, data);
        dispatch({ type: Types.REFRESH_ALI_HOST_LIST_FAIL });
      }
    }).catch(err => {
      console.log('获取服务器列表失败');
      message.error(err.message);
      dispatch({ type: Types.REFRESH_ALI_HOST_LIST_FAIL });
    });
  };
}

/**
 * 私有化配置新增
 * @param config  配置详情
 * @return {(function(*): void)|*}
 */
export function onNewConfig(config) {
  return dispatch => {
    optionConfig(dispatch, 'post', config, result => {
      if (result) {
        message.success(i18n.t('add_success_title'));
      } else {
        message.success(i18n.t('add_success_fail'));
      }
    });
  };
}

/**
 * 私有化配置更新
 * @param config
 */
export function onUpdateConfig(config) {
  return dispatch => {
    optionConfig(dispatch, 'put', config, result => {
      if (result) {
        // message.success(i18n.t('edit_success_title'));
      } else {
        message.success(i18n.t('edit_success_fail'));
      }
    });
  };
}


export function onDeleteConfig(config) {
  return dispatch => {
    if (config?.deviceCnt > 0) {
      Modal.warning({
        title: i18n.t('config_has_devices').replace('%1', config.name).replace('%2', config.deviceCnt),
      });
      return;
    }

    Modal.confirm({
      title: i18n.t('confirm_to_delete_config').replace('%$', config.name),
      onOk: () => optionConfig(dispatch, 'delete', { privateConfigId: [config.id] }, result => {
        if (result) {
          message.success(i18n.t('delete_success'));
        } else {
          message.error(i18n.t('delete_failed'));
        }
      }),
    });
  };
}

export function onRefreshProducts(language) {
  return dispatch => {
    dispatch({ type: Types.REFRESH_PRODUCT_LIST });
    http('get', HttpURLS.REFRESH_PRODUCTS_LIST)
      .then(res => {
        const { code, data } = res?.data ?? {};
        console.log('code:', code, 'data:', data);
        if (code === 200) {
          const newProducts = [];
          data.products.forEach(product => {
            newProducts.push({
              value: product.code, label: language.includes('zh') ? product.name : product.en_name,
              ble: `${ !product.noBleSetting }`,
            });
          });
          dispatch({ type: Types.REFRESH_PRODUCT_LIST_SUCCESS, products: newProducts });
        } else {
          dispatch({ type: Types.REFRESH_PRODUCT_LIST_FAIL });
        }
      }).catch(err => {
      message.error(err.message);
      dispatch({ type: Types.REFRESH_PRODUCT_LIST_FAIL });
    });
  };
}

function optionConfig(dispatch, method, config, callback = () => {}) {
  console.log('config:', JSON.stringify(config));
  dispatch({ type: Types.EDIT_CONFIG });
  http(method, HttpURLS.EDIT_CONFIG, config).then(res => {
    const { code, data } = res.data;
    if (code === 200) {
      console.log('成功：', data);
      dispatch({ type: Types.EDIT_CONFIG_SUCCESS });
      callback(true);
      updateConfigList(dispatch);
    } else {
      callback(false);
      dispatch({ type: Types.EDIT_CONFIG_FAIL });
    }
  }).catch(err => {
    message.error(err.message);
    console.error('配置操作失败', method, err);
    dispatch({ type: Types.EDIT_CONFIG_FAIL });
  });
}

function updateConfigList(dispatch) {
  dispatch({ type: Types.REFRESH_CONFIG_LIST });
  http('get', HttpURLS.REFRESH_CONFIG_LIST).then(res => {
    console.log('获取列表成功：', res);
    const { code, data } = res.data;
    if (code === 200) {
      const { configList = [], total = 0 } = data;
      let newConfigList = [];
      configList.forEach((record) => {
        const { id, name, networkConfig, reportConfig, encryptConfig, deviceCnt = 0 } = record;
        newConfigList.push({
          id,
          name,
          type: formatNetType(networkConfig?.type),
          encryptType: formatEncryptType(encryptConfig?.type),
          deviceCnt,
          operate: '', ...reportConfig,
          reportInterval: formatTime(reportConfig?.reportInterval),
          collectInterval: formatTime(reportConfig?.collectInterval),
          originalData: record,
        });
      });
      dispatch({
        type: Types.REFRESH_CONFIG_LIST_SUCCESS, total, configList: newConfigList,
      });
    } else {
      dispatch({
        type: Types.REFRESH_CONFIG_LIST_FAIL,
      });
    }
  }).catch(err => {
    console.error('获取列表失败：', err);
    message.error(err.message);
    dispatch({
      type: Types.REFRESH_CONFIG_LIST_FAIL,
    });
  });
}
